import React, { } from 'react'
import { DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { ContactType } from '../../../constants/DashboardConf'
import { CounterTitle, HorizontalFormWrapper } from '../dashboard.styled'

const { EMAIL, LINE, WHATSAPP, INSTAGRAM, FACEBOOK, TWITTER, LINKEDIN, YOUTUBE, TIKTOK } = ContactType
const contactTypeOptions = [EMAIL, LINE, WHATSAPP, INSTAGRAM, FACEBOOK, TWITTER, LINKEDIN, YOUTUBE, TIKTOK]?.map(i => ({ value: i, label: i }))
function ProfileSetting (props) {
  const { defConfig, defPlaceholder, piiSchema, counter, handleDelCounter, handleAddCounter } = props
  const { t: ln_t } = useTranslation()

  return (
    <>
      <Form.Item {...defConfig('profilePicture', 'select', false)}>
        <Select showSearch allowClear placeholder={defPlaceholder('profilePicture', 'select')} options={piiSchema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('name', 'select', false)}>
        <Select showSearch allowClear placeholder={defPlaceholder('name', 'select')} options={piiSchema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('email', 'select', false)}>
        <Select showSearch allowClear placeholder={defPlaceholder('email', 'select')} options={piiSchema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('phoneNumber', 'select', false)}>
        <Select showSearch allowClear placeholder={defPlaceholder('phoneNumber', 'select')} options={piiSchema} optionFilterProp="children" />
      </Form.Item>
      {counter?.map(key => (
        <React.Fragment key={key}>
          <CounterTitle>
            {ln_t('dashboard.contact')} #{key}
            <DeleteTwoTone style={{ cursor: 'pointer' }} twoToneColor="#707070" onClick={() => handleDelCounter(key)} />
          </CounterTitle>
          <HorizontalFormWrapper>
            <Form.Item name={`contactType-${key}`} rules={[{ required: true, message: defPlaceholder('contactType', 'select') }]}>
              <Select showSearch placeholder={defPlaceholder('contactType', 'select')} options={contactTypeOptions} optionFilterProp="children" />
            </Form.Item>
            <Form.Item name={`contact-${key}`} rules={[{ required: true, message: defPlaceholder('contact', 'select') }]}>
              <Select showSearch allowClear placeholder={defPlaceholder('contact', 'select')} options={piiSchema} optionFilterProp="children" />
            </Form.Item>
          </HorizontalFormWrapper>
        </React.Fragment>
      ))}
      <Button type="default" style={{ width: '100%', marginTop: '8px' }} icon={<PlusOutlined />} onClick={handleAddCounter}>
        {ln_t('util.add')} {ln_t('dashboard.contact')}
      </Button>
    </>
  )
}

export default ProfileSetting
